module.exports = __webpack_public_path__ + "img/link_yuu_id.29edd94.png";